
import Api from '@/api'



const loginUser= (payload) => {        
    return Api.post('api/login' , payload)       
};
const registerUser= (payload) => {        
    return Api.post('api/register' , payload)       
};
const fetchRegistercompanies = () => {        
    return Api.get('api/registercompanies')
};
const fetchAuthenticatedUser = () => {        
    return Api.get('api/user')
};

export default {
  loginUser,
  registerUser,
  fetchAuthenticatedUser,
  fetchRegistercompanies
};